import { render, staticRenderFns } from "./admin-login.vue?vue&type=template&id=54b75ee7&scoped=true&"
import script from "./admin-login.vue?vue&type=script&lang=js&"
export * from "./admin-login.vue?vue&type=script&lang=js&"
import style0 from "./admin-login.vue?vue&type=style&index=0&id=54b75ee7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b75ee7",
  null
  
)

export default component.exports